import { map, filter } from 'rxjs/operators';
// ---- external imports ----

import * as hintsActionTypes from '~/store/hints/actionTypes';
import { levelActions } from '~/store/actions';
// ---- internal imports ----

import {
	LEVEL_COMPLETED,
	LEVEL_CREATE_NEW_GAME,
	LEVEL_LOAD_GAME,
	LEVEL_UPDATE_MISSIONS
} from '../actionTypes';
// ---- local imports ----

const ignoreActionTypesLevelEpic = [LEVEL_CREATE_NEW_GAME,
	LEVEL_LOAD_GAME,
	LEVEL_UPDATE_MISSIONS,
	LEVEL_COMPLETED];

const missionHandlerEpic = (action$) => action$.pipe(
	filter((action) => !action.type.includes('@@')
		&& !ignoreActionTypesLevelEpic.includes(action.type)
		&& !action.type.startsWith(hintsActionTypes.PREFIX)),
	map((action) => levelActions.missionHandler(action))
);

export default missionHandlerEpic;
